import { render, staticRenderFns } from "./UserDetail_Tutor_ReviewRating.vue?vue&type=template&id=22b04476&"
import script from "./UserDetail_Tutor_ReviewRating.vue?vue&type=script&lang=js&"
export * from "./UserDetail_Tutor_ReviewRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports